import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'SelectServiceRssModal',
  components: {
    Loading
  },
  data () {
    return {
      loading: true,

      // テーブルオプション
      tableColumns: [
        'checkbox',
        'serviceRssId',
        'rssName',
        'rssURL',
        // 'rssStatus',
      ],
      tableData: [],
      tableOptions: {
        headings: {
          checkbox: '',
          serviceRssId: 'RSSID',
          rssName: 'RSS名',
          rssURL: 'URL',
          rssStatus: 'ステータス',
        },
        columnsClasses: {
          checkbox: 'wp-3',
          serviceRssId: 'wp-5',
          rssName: '',
          rssURL: '',
          rssStatus: '',
        },
        sortable: [
          'serviceRssId',
          'rssName',
          'rssURL',
          'rssStatus'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts('RSS'),
        perPage: Constants.TableOptions.perPage.modal,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      // チェックリスト
      checkList: []
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      active: state => state.selectServiceRssModal.active,

      // form
      serviceId: state => state.selectServiceRssModal.serviceId,
      value: state => state.selectServiceRssModal.value,

      // model
      serviceRssModel: state => state.selectServiceRssModal.serviceRssModel,
    }),
    ...mapGetters({
      isSmartPhone: 'core/isSmartPhone'
    }),

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    disableConfirmButton () {
      return this.checkList.length === 0
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'selectServiceRssModal/loadModel',
      hide: 'selectServiceRssModal/hide',
      setValue: 'selectServiceRssModal/setValue',
      reset: 'selectServiceRssModal/reset'
    }),

    init () {
      this.loading = true

      // storeをリセット
      // this.reset()

      // 選択済みサービス配信タイプUUIDをチェックリストに格納
      if (this.value &&
        this.value.length) {
        let data = $.extend(true, [], this.value)
        this.$set(this, 'checkList', data)
      }

      //
      let serviceRssParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        serviceRssParams: serviceRssParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.serviceRssModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'checkbox':
          return props.row.serviceRssUuid
        case 'rssStatus':
          return Utility.getConstantsLabel(['Status'], value)
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    selectItem (props) {
      console.log(this.checkList)

      // 選択されたファイル情報をstoreに保持
      this.setValue(this.checkList)

      this.closeModal()
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}